import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.webidl = languageMap["web-idl"] = bracketIndenting()
